import React from "react"
import { cn } from "../utils"

export type CommandHintProps = React.ComponentPropsWithoutRef<"span">

/**
 * A trailing hint shown only when the parent `Command.Item` is active. Pair it
 * with `Command.Shortcut` to swap the shortcut for an action hint (e.g. "Press
 * Enter") on the highlighted row.
 */
export function CommandHint({
  className,
  children,
  ...props
}: CommandHintProps) {
  return (
    <span
      className={cn(
        "ml-auto hidden shrink-0 items-center gap-1 text-[0.6875rem] leading-4 text-gray-700",
        "group-data-[selected=true]:flex",
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
}

CommandHint.displayName = "Command.Hint"
